import React from 'react';
import { Page } from '../Page';
import { Dumbbell, Shield, Award } from 'lucide-react';
export function SupplementCreatine() {
  return <Page pageNumber={27} variant="light" data-id="element-2860">
      <div className="flex h-full gap-10" data-id="element-2861">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2862">
          <img src="https://cdn.magicpatterns.com/uploads/kEu8GqakDxEz3D2wvQLn1t/pasted-image.png" alt="Thorne Creatine" className="w-full max-w-[280px] object-contain" data-id="element-2863" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2864">
          <div className="mb-6 pt-4" data-id="element-2865">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2866">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2867">
              Creatine
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2868">
              Protect your muscle while losing fat
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2869" />
          </div>

          <div className="mb-8" data-id="element-2870">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2871">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2872">
              The #1 concern with GLP-1 weight loss is muscle loss, with up to
              30-40% of weight lost can be lean mass. Creatine is one of the
              most evidence-backed supplements for preserving and building lean
              body mass, and it supports the exercise capacity needed to
              counteract muscle loss during caloric deficit.
            </p>
          </div>

          <div className="mb-8" data-id="element-2873">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2874">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2875">
              <li className="flex gap-2" data-id="element-2876">
                <Dumbbell className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2877" />
                <span data-id="element-2878">
                  Preserves lean body mass during rapid weight loss and supports
                  strength
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2879">
                <Shield className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2880" />
                <span data-id="element-2881">
                  Supports exercise capacity when energy intake is reduced
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2882">
                <span className="text-tealslate shrink-0" data-id="element-2883">•</span>
                <span data-id="element-2884">
                  Helps prevent muscle cramps and dehydration (common GLP-1 side
                  effects)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2885">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2886" />
                <span data-id="element-2887">
                  Micronized creatine monohydrate, easy to mix, no taste/odor,
                  NSF Certified for Sport
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2888">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2889">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2890">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2891">
                <strong data-id="element-2892">1 scoop (5g) daily</strong>. Mix with water or add to
                protein shake
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2893">
                450g tub (~90 servings) • Can be taken any time of day
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2894">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2895" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2896">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}